module.exports = __webpack_public_path__ + "img/water_diagram.4733c609.png";